import React from "react";
import classes from "./UserStatsCard.module.css";
import { NewSignupIcon } from "../../constant";
import { formatNumberWithCommas } from "../../helpers";
import { statsPeriod } from "../../data";
const UserStatsCard = ({number,period,title,icon}) => {
  return (
    <ul className={classes.wrapper}>
      <li>
        {icon || <NewSignupIcon className={classes.icon} />}
      </li>
      <li>
        <div className={classes.numberContainer}>
          <h2 className={classes.number}>
            {formatNumberWithCommas(number ||0)}
          </h2>
          <p className={classes.month}>{statsPeriod.find(item => item.value === period)?.label || "This Month"}</p>
        </div>
        <p className={classes.title}>{title || "New Signups"}</p>
      </li>
    </ul>
  );
};

export default UserStatsCard;
